export const DEFAULT_ERROR_MESSAGE =
  'Ocorreu um erro inesperado na aplicação. Tente novamente';
